import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { TErrorModalProps } from './ErrorContainer'

export type TErrorType =
  | 'none'
  | 'handled'
  | 'serviceUnreachable'
  | 'networkError'
  | 'operationError'
  | 'userErrors'
  | 'otherError'
  | 'authError'

export type TError = {
  type: TErrorType
  payload?: Error | RoA<string>
  sentryEventId?: string
}

type TModalProps = Pick<TErrorModalProps, 'sentryEventId' | 'customerValues'>

export type TErrorPresenterOptions = TModalProps &
  (
    | {
        headerText: string
        errorText: string | RoA<string>
        /**
   defines, how the error modal will behave and look like
   * - `handled`: modal with confirm button, default type, *pass custom `headerText` & `errorText`*
   * - `none`: modal with app restart button, *pass custom `headerText` & `errorText`*
   * - `otherError`: catch-all modal with non-specific texts and restart button
   * - `serviceUnreachable`, `networkError`, `operationError`, `userErrors`: modal with confirm button and predefined `headerText` & `errorText`, these are more for an app internal use
   */
        errorType: Extract<TErrorType, `none` | `handled`>
      }
    | {
        headerText?: undefined
        errorText?: undefined
        /**
   defines, how the error modal will behave and look like
   * - `handled`: modal with confirm button, default type, *pass custom `headerText` & `errorText`*
   * - `none`: modal with app restart button, *pass custom `headerText` & `errorText`*
   * - `otherError`: catch-all modal with non-specific texts and restart button
   * - `serviceUnreachable`, `networkError`, `operationError`, `userErrors`: modal with confirm button and predefined `headerText` & `errorText`, these are more for an app internal use
   */
        errorType: Exclude<TErrorType, `none` | `handled`>
      }
  )

export type TErrorHandler = {
  presentError: (options: TErrorPresenterOptions) => void
  setError: (error: TError) => void
  errorType: TErrorType
}

type TProps = RequiredChildren & {
  errorHandler: TErrorHandler
}

const [Provider, useErrorHandlerCtx] = createContext<TErrorHandler>(`ErrorHandler`)

export const ErrorHandlerProvider: React.FC<TProps> = ({ children, errorHandler }) => {
  return <Provider value={errorHandler}>{children}</Provider>
}

export { useErrorHandlerCtx }
